
define('text!templates/layouts/content/layout-content.html',[],function () { return '<div id="main" class="column">\n    <div id="page" class="scrollable"></div>\n</div>\n<div id="info" class="column"></div>\n';});

